"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plugins = exports.PluginKey = void 0;
var PluginKey;
(function (PluginKey) {
    PluginKey[PluginKey["PUBSUB"] = 0] = "PUBSUB";
})(PluginKey = exports.PluginKey || (exports.PluginKey = {}));
class Plugins {
}
exports.Plugins = Plugins;
_a = Plugins;
Plugins.registered = new Map();
Plugins.register = (candidates, env) => {
    if (candidates && candidates.length) {
        for (const candidate of candidates) {
            if (!_a.registered.has(candidate.key)) {
                candidate.register(env);
                _a.registered.set(candidate.key, candidate);
            }
        }
    }
};
